import React from 'react';
import { Error } from './Error';

export class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      this.setState({
        hasError: true
      })
    }
  
    componentDidCatch(error, errorInfo) {
      // You can also log the error to an error reporting service

      this.setState({
        hasError: true
      })
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return <Error />;
      }
  
      return this.props.children; 
    }
}